import {Partecipant} from "./partecipant";

export class CondivisionePosizione {

  _id: string;
  url: string;
  target_imei: string;
  id_organization: string;
  expiration_date: number;
  emails: string[] = [];
  name: string;
  note: string;
  $is_expired: boolean;

  $participant: Partecipant;
  $show_detail: boolean;

  constructor(data?: any){
    if (data) this.setData(data);
  }

  setData(data: any){
    this._id = data._id;
    this.url = data.url;
    this.target_imei = data.target_imei;
    this.id_organization = data.id_organization;
    this.expiration_date = data.expiration_date;
    this.emails = data.emails;
    this.name = data.name;
    this.note = data.note;

    this.$is_expired = Date.now() > this.expiration_date;
  }
}
